import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.72,6.4801h16.56v1.84H3.72v-1.84M3.72,11.0801h16.56v1.84H3.72v-1.84M3.72,15.6801h16.56v1.84H3.72v-1.84Z" }));
export default SvgMenu;
